import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, CONTACT } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const loadCheckout = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export const usePay = () => {
  const [paying, setPaying] = useState(false);
  const { user, checkAuth } = useAuth();
  const navigate = useNavigate();

  const pay = async (serviceIds, label) => {
    setPaying(true);
    try {
      if (!(await loadCheckout())) throw new Error("Could not load Razorpay. Check your connection.");
      const { data: order } = await api.post("/payments/order", { service_ids: serviceIds });
      const rz = new window.Razorpay({
        key: order.key_id,
        amount: order.amount,
        currency: order.currency,
        order_id: order.order_id,
        name: CONTACT.company,
        description: label || order.plan,
        prefill: { name: user?.name || "", email: user?.email || "" },
        theme: { color: "#00F0FF" },
        handler: async (res) => {
          try {
            await api.post("/payments/verify", res);
            if (user) checkAuth();
            navigate(`/payment/success/${order.order_id}`);
          } catch {
            toast.error("We couldn't verify the payment. If money was deducted, please contact us.");
          }
        },
        modal: { ondismiss: () => setPaying(false) },
      });
      rz.on("payment.failed", (r) => toast.error(r?.error?.description || "Payment failed. Please try again."));
      rz.open();
    } catch (e) {
      toast.error(e?.response?.data?.detail || e?.message || "Could not start payment.");
      setPaying(false);
    }
  };

  return { pay, paying };
};
